/*
 * Public API Surface of ngx-lib/files-uploader
 */
export * from './files-uploader.module';
export * from './files-uploader.component';
